import { render } from "./Index.vue?vue&type=template&id=18511d61&scoped=true&lang=html"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=18511d61&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18511d61"

export default script